import React, {Fragment} from "react";
import {ApplicationState, ConnectedReduxProps} from "@reducers/index";
import {Subscription} from "@models/subscription";
import SubscriptionForm from "@components/subscriptions/Form";
import {injectIntl} from "react-intl";
import subscriptionApi from "@api/subscription";


interface PropsFromState {
  loading: boolean;
  data: Subscription[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class SubscriptionFormPage extends React.Component<AllProps> {
  state = {
    subscription: null,
    subscription_id: this.props.match.params.id,
    is_fetched: false
  };
  
  componentDidMount() {
    if (this.state.subscription_id) {
      this.fetchItem();
    }
  }
  
  fetchItem = () => {
    subscriptionApi
      .getItem({
        params: {
          id: this.state.subscription_id,
        }
      })
      .then(({data}) => {
        this.setState({
          subscription: data
        });
      })
      .catch(error => {
      });
  };
  
  updateRequest = ({payload, params, onSuccessCallback, onErrorCallback, id}) => {
    subscriptionApi.update({
        payload,
        params:{
          id : params.id
        },
      })
      .then((data) => onSuccessCallback(data))
      .catch(error => onErrorCallback(error))
  };
  
  createRequest = ({payload, onSuccessCallback, onErrorCallback}) => {
    subscriptionApi.create({
        payload,
      })
      .then((data) => onSuccessCallback(data))
      .catch(error => onErrorCallback(error))
  };
  
  getContent = () => {
    if (this.state.subscription_id && !this.state.subscription) {
      return null;
    }
    
    return (
      <SubscriptionForm
        subscription={this.state.subscription}
        intl={this.props.intl}
        id={this.state.subscription_id}
        listUrl={"/UserSubscriptions"}
        history={this.props.history}
        updateRequest={this.updateRequest}
        createRequest={this.createRequest}
      />
    );
  };
  
  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}


export default injectIntl(SubscriptionFormPage)
